"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _threePartyConfiguration = require("@/api/appBasicSetup/threePartyConfiguration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ThreePartyConfiguration',
  data: function data() {
    return {
      ruleForm: {
        accessKey: '',
        secretKey: '',
        bucketName: '',
        endpoint: '',
        type: 1 // 类型 0-共有 1-私有
      },
      ruleForm1: {
        accessKey: '',
        secretKey: '',
        bucketName: '',
        endpoint: '',
        type: 0 // 类型 0-共有 1-私有
      },
      rules: {
        accessKey: [{
          required: true,
          message: '请输入AccessKey',
          trigger: 'blur'
        }],
        secretKey: [{
          required: true,
          message: '请输入secretKey',
          trigger: 'blur'
        }],
        bucketName: [{
          required: true,
          message: '请输入bucketName',
          trigger: 'blur'
        }],
        endpoint: [{
          required: true,
          message: '请输入endpoint',
          trigger: 'blur'
        }]
      },
      rules1: {
        accessKey: [{
          required: true,
          message: '请输入AccessKey',
          trigger: 'blur'
        }],
        secretKey: [{
          required: true,
          message: '请输入secretKey',
          trigger: 'blur'
        }],
        bucketName: [{
          required: true,
          message: '请输入bucketName',
          trigger: 'blur'
        }],
        endpoint: [{
          required: true,
          message: '请输入endpoint',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.showOssConfigDetail();
    this.showOssConfigDetail1();
  },
  methods: {
    showOssConfigDetail: function () {
      var _showOssConfigDetail2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                type: 1
              };
              _context.n = 1;
              return (0, _threePartyConfiguration.showOssConfigDetail)(params);
            case 1:
              res = _context.v;
              this.ruleForm.accessKey = res.data.accessKey;
              this.ruleForm.secretKey = res.data.secretKey;
              this.ruleForm.bucketName = res.data.bucketName;
              this.ruleForm.endpoint = res.data.endpoint;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function showOssConfigDetail() {
        return _showOssConfigDetail2.apply(this, arguments);
      }
      return showOssConfigDetail;
    }(),
    showOssConfigDetail1: function () {
      var _showOssConfigDetail3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                type: 0
              };
              _context2.n = 1;
              return (0, _threePartyConfiguration.showOssConfigDetail)(params);
            case 1:
              res = _context2.v;
              this.ruleForm1.accessKey = res.data.accessKey;
              this.ruleForm1.secretKey = res.data.secretKey;
              this.ruleForm1.bucketName = res.data.bucketName;
              this.ruleForm1.endpoint = res.data.endpoint;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function showOssConfigDetail1() {
        return _showOssConfigDetail3.apply(this, arguments);
      }
      return showOssConfigDetail1;
    }(),
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认修改此配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.setOssConfig();
          });
        } else {
          return false;
        }
      });
    },
    submitForm1: function submitForm1(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.$confirm('是否确认修改此配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this2.setOssConfig1();
          });
        } else {
          return false;
        }
      });
    },
    setOssConfig: function () {
      var _setOssConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context3.n = 1;
              return (0, _threePartyConfiguration.setOssConfig)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                });
                this.showOssConfigDetail();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function setOssConfig() {
        return _setOssConfig2.apply(this, arguments);
      }
      return setOssConfig;
    }(),
    setOssConfig1: function () {
      var _setOssConfig3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              params = (0, _objectSpread2.default)({}, this.ruleForm1);
              _context4.n = 1;
              return (0, _threePartyConfiguration.setOssConfig)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                });
                this.showOssConfigDetail1();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function setOssConfig1() {
        return _setOssConfig3.apply(this, arguments);
      }
      return setOssConfig1;
    }()
  }
};